import moment from 'moment';
import { arrayOf, func, number, object, string } from 'prop-types';
import { path } from 'ramda';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import { selectors, actions } from 'store/newDocumentStore';

import Intro from '../Contents/Intro';
import Rehabilitation1 from '../Contents/Rehab1';
import Rehabilitation2 from '../Contents/Rehab2';
import Rehabilitation3 from '../Contents/Rehab3';
import Rehabilitation4 from '../Contents/Rehab4';
import Rehabilitation5 from '../Contents/Rehab5';
import Rehabilitation6 from '../Contents/Rehab6';
import Rehabilitation7 from '../Contents/Rehab7';
import RehabilitationFollow from '../Contents/RehabFollow';
import { getAllCommitsData } from 'lib/documentHandling';

export const StepperContext = React.createContext();
class MakeStepperContent extends React.Component {
  onCancelRehab = () => {
    if (this.props.viewingId) return;
    // Cancel the rehab, close document with commit and cancelled:
    const { done, editingDocumentId, editedCommit } = this.props;
    done('onlineRehabilitation', editingDocumentId, editedCommit.commitId, { cancelled: true });
    setTimeout(() => {
      // Navigate back to rehabs so that the page will reload with updated documents
      window.location.replace('/documents/onlineRehabilitation');
    }, 200);
  };

  onChange = valueObject => {
    const { step, change } = this.props;
    const { formValues } = this.context;

    const newField = 'rehab' + step;
    const newValue = { ...formValues[newField], ...valueObject };

    change('onlineRehabilitation', newField, newValue);
  };
  onChangeParent = (field, value) => {
    const { change } = this.props;
    change('onlineRehabilitation', field, value);
  };
  setFinished = () => {
    const { step } = this.props;
    const { formValues } = this.context;
    if (step && !path(['rehab' + step, 'finished'], formValues)) {
      this.onChange({ finished: moment().toISOString() });
    }
  };

  getChildContext() {
    // According to react docs, getChildContext should not be used.
    // Change to context provider after react update, and this.context can be used <TODO>
    // const { formValues } = this.context;
    const { fm, changeStep, create, done, cancel, edit, editingDocumentId, viewingId } = this.props;
    const { formatMessage } = this.props.intl;
    const fmString = (id, values) => formatMessage({ id }, values);

    const editingContextProps = editingDocumentId
      ? {
          onChange: this.onChange,
          onChangeParent: this.onChangeParent,
          create,
          done,
          cancel,
          edit,
          setFinished: this.setFinished,
        }
      : {
          viewingIdContext: viewingId,
          formValues: getAllCommitsData(this.props.documents.find(d => d.documentId === viewingId)),
          onChange: () => '',
          setFinished: () => '',
        };

    return {
      fm,
      fmString,
      changeStep,
      editingDocumentId,
      ...editingContextProps,
    };
  }

  render() {
    const { step } = this.props;

    let content = null;

    switch (step) {
      default:
        content = <div />;
        break;

      case 0:
        content = <Intro onCancelRehab={this.onCancelRehab} />;
        break;

      case 1:
        content = <Rehabilitation1 documents={this.props.documents} />;
        break;

      case 2:
        content = <Rehabilitation2 documents={this.props.documents} />;
        break;

      case 3:
        content = <Rehabilitation3 documents={this.props.documents} />;
        break;

      case 4:
        content = <Rehabilitation4 documents={this.props.documents} />;
        break;

      case 5:
        content = <Rehabilitation5 documents={this.props.documents} />;
        break;

      case 6:
        content = <Rehabilitation6 documents={this.props.documents} />;
        break;

      case 7:
        content = <Rehabilitation7 documents={this.props.documents} />;
        break;

      case 8:
        content = <RehabilitationFollow documents={this.props.documents} />;
        break;
    }
    return content;
  }
}

MakeStepperContent.propTypes = {
  step: number,
  fm: func,
  changeStep: func,
  editingDocumentId: string,
  editedCommit: object,
  change: func,
  create: func,
  done: func,
  cancel: func,
  edit: func,
  documents: arrayOf(object),
  intl: object,
  viewingId: string,
};

MakeStepperContent.contextTypes = {
  formValues: object,
};

MakeStepperContent.childContextTypes = {
  fm: func, // FormatHTMLMessage from parent
  fmString: func, // String fm from intl
  changeStep: func,
  onChange: func, // Change data in current rehab session
  onChangeParent: func, // Change data in the whole document
  commitPut: func,
  create: func,
  done: func,
  cancel: func,
  edit: func,
  documents: arrayOf(object),
  editingDocumentId: string,
  formValues: object, // Form values for the whole document being edited
  setFinished: func, // Set finished field on a rehab session
  viewingIdContext: string,
};

const mapStateToProps = (state, ownProps) => {
  const names = ['onlineRehabilitation', 'status', 'eq5d', 'msnq', 'fsmc', 'fatigueTrackingDiary'];
  const documents = names.flatMap(n => {
    const moduleState = selectors.selectModuleState(n, state.newDocs);
    if (!moduleState || !moduleState.documents) return [];
    return moduleState.documents;
  });
  return { documents };
};

export default connect(mapStateToProps, {
  change,
  create: actions.createDocumentAndCommit,
  done: actions.finishCommit,
  cancel: actions.discardCommit,
  edit: actions.createCommit,
})(injectIntl(MakeStepperContent));
